<template>
  <VueEditor
    v-model="content"
    use-custom-image-handler
    :editor-toolbar="customToolbar"
    @image-added="handleImageAdded"
  />
</template>
<script>
import { VueEditor, Quill } from 'vue2-editor';
import { v4 as uuidv4 } from 'uuid';
import axClient from '@/services';
// import axios from 'axios';

export default {
  name: 'Editor',
  components: { VueEditor },
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editor: null,
      ossData: {}, // 阿里云返回的ossData
      cdnData: {},
      content: '',
      customToolbar: [
        // [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ header: 1 }, { header: 2 }],
        [{ size: ['12px', '14px', '16px', '18px', '24px', '36px', '48px'] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['image'],
        ['clean'], // remove formatting button
      ],
    };
  },
  watch: {
    html(val) {
      console.log(val);
      this.content = val;
      // this.editor.txt.html(val);
    },
    content(val) {
      this.$emit('update:html', val);
    },
  },
  mounted() {
    const Size = Quill.import('attributors/style/size');
    Size.whitelist = ['12px', '14px', '16px', '18px', '24px', '36px', '48px'];
    Quill.register(Size, true);
  },
  methods: {
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const uuid = uuidv4().replaceAll('-', '');
      const fileName = `${uuid}.${file.name.split('.').pop()}`;
      const newFile = new File([file], fileName, { type: file.type });
      newFile.url = file.url;
      this.ossData = await axClient.common.aliOssDirEnum();
      this.cdnData = await axClient.common.aliCdnDirEnum();
      const fileFormData = new FormData();
      fileFormData.append('name', newFile.name);
      fileFormData.append('key', `${this.ossData.dir}\${filename}`);
      fileFormData.append('policy', this.ossData.policy);
      fileFormData.append('OSSAccessKeyId', this.ossData.accessid);
      fileFormData.append('callback', this.ossData.callback);
      fileFormData.append('signature', this.ossData.signature);
      fileFormData.append('file', newFile);
      // const data = await axios.post(this.ossData.host, fileFormData);
      const data = await axClient.common.uploadFile(this.ossData.host, fileFormData);
      if (data.Status === 'OK') {
        let filePath = '';
        if (process.env.NODE_ENV === 'development') {
          filePath = `${this.ossData.host}${this.ossData.dir}${newFile.name}`;
        } else {
          filePath = `${this.cdnData.host}${this.cdnData.dir}${newFile.name}`;
        }
        Editor.insertEmbed(cursorLocation, 'image', filePath);
        resetUploader();
      } else {
        this.$message.error('上传失败');
      }
    },
  },
};
</script>
<style lang="scss" >
.ql-picker {
  display: flex;
  align-items: center;
}
</style>
